import { Component, inject } from '@angular/core';
import { MatProgressBarModule, ProgressBarMode } from '@angular/material/progress-bar';

import { HttpEventLoaderService } from '../service';

@Component({
  selector: 'app-http-event-loader',
  template: `
    <div class="sticky top-0 h-[var(--tva-http-event-loader-height)] w-full z-50">
      @if (loaderService.isLoading()) {
        <mat-progress-bar class="spinner" [color]="color" [mode]="mode"> </mat-progress-bar>
      }
    </div>
  `,
  imports: [MatProgressBarModule],
})
export class HttpEventLoaderComponent {
  loaderService = inject(HttpEventLoaderService);

  color: 'primary' | 'accent' = 'primary';
  mode: ProgressBarMode = 'indeterminate';
}
